export default import.meta.ROLLDOWN_FILE_URL__ewJD0zO9$SsiDvawfmAUw